<template>
  <div>
    <b-form>
      <div v-if="panduanKewajiban" class="mb-2">
        <button type="button" class="btn btn-warning text-white" @click="$bvModal.show(`modal-indentify${page}`)">
          <i class="fa fa-question-circle" />
          Panduan
        </button>
      </div>
      <span style="font-weight: 600">{{ formTitle }}</span>
      <div class="row mb-3">
        <div :class="['col-md-12 mt-3', { 'pe-none': is_selesai }]">
          <label>Status kewajiban yang telah dilakukan <span class="text-danger">*</span></label>
          <div style="width: 200px">
            <v-select
              v-model="form.status_kewajiban"
              id="status_kewajiban"
              :reduce="(data) => data.value"
              label="text"
              :options="optionStatus"
              name="Status"
              v-validate="'required'"
              :class="{
                input: true,
                'is-danger': errors.has('Status'),
              }"
            />
          </div>
          <span class="text-danger" v-if="errors.has('Status')">
            {{ errors.first('Status') }}
          </span>
        </div>

        <div v-if="form.status_kewajiban === 'Sudah'" :class="['row']">
          <div class="col-md-6 mt-3">
            <label>Bentuk Kegiatan <span class="text-danger">*</span></label>
            <b-form-textarea
              v-model="form.bentuk_kegiatan"
              id="bentuk_kegiatan"
              name="Bentuk Kegiatan"
              v-validate="'required'"
              :disabled="is_selesai"
              :class="{ input: true, 'is-danger': errors.has('Bentuk Kegiatan') }"
              style="background-color: white"
              rows="3"
            ></b-form-textarea>
            <span class="text-danger" v-if="errors.has('Bentuk Kegiatan')">
              {{ errors.first('Bentuk Kegiatan') }}
            </span>
          </div>
          <div class="col-md-3 mt-3">
            <label>Nominal CSR <span class="text-danger">*</span></label>
            <div class="input-rupiah">
              <b-form-input
                id="nominal_csr"
                v-model="form.nominal_csr"
                name="Nominal CSR"
                v-validate="'required'"
                :disabled="is_selesai"
                :class="{ input: true, 'is-danger': errors.has('Nominal CSR') }"
                style="background-color: white"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/^0(?!$)+/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')"
              ></b-form-input>
              <div class="text-units">
                <span>Rp </span>
              </div>
            </div>
            <span class="text-danger" v-if="errors.has('Nominal CSR')">
              {{ errors.first('Nominal CSR') }}
            </span>
          </div>
          <div class="w-100"></div>
          <div class="col-md-6 mt-3">
            <label>Lokasi Kegiatan <span class="text-danger">*</span></label>
            <b-form-input
              v-model="form.lokasi_kegiatan"
              id="lokasi_kegiatan"
              v-validate="'required'"
              name="Lokasi Kegiatan"
              :disabled="is_selesai"
              :class="{ input: true, 'is-danger': errors.has('Lokasi Kegiatan') }"
              style="background-color: white"
            ></b-form-input>
            <span class="text-danger" v-if="errors.has('Lokasi Kegiatan')">
              {{ errors.first('Lokasi Kegiatan') }}
            </span>
          </div>
          <div class="col-md-3 mt-3">
            <label>Luasan CSR <span class="text-danger">*</span></label>
            <div class="input-units">
              <b-form-input
                v-model="form.luasan_csr"
                id="luasan_csr"
                v-validate="'required'"
                name="Luasan CSR"
                :class="{
                  input: true,
                  'is-danger': errors.has('Luasan CSR'),
                }"
                oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/^\./,'').replace(/^0(?=[0-9])/, '').replace(/(\..*)\./g,'$1')"
                :disabled="is_selesai"
                style="background-color: white"
              ></b-form-input>
              <div class="text-units">
                <span>{{ form.luasan_csr }}</span>
                <span> ha</span>
              </div>
            </div>
            <!-- <b-form-input
              id="luasan_csr"
              v-model="form.luasan_csr"
              name="Luasan CSR"
              v-validate="'required'"
              :disabled="is_selesai"
              :class="{ input: true, 'is-danger': errors.has('Luasan CSR') }"
              style="background-color: white"
            ></b-form-input> -->
            <span class="text-danger" v-if="errors.has('Luasan CSR')">
              {{ errors.first('Luasan CSR') }}
            </span>
          </div>
          <div class="w-100"></div>
          <div class="col-md-6 mt-3">
            <label>Waktu Pelaksanaan Kegiatan <span class="text-danger">*</span></label>
            <b-form-input
              v-model="form.waktu_pelaksanaan"
              id="waktu_pelaksanaan"
              v-validate="'required'"
              name="Waktu Pelaksanaan"
              :disabled="is_selesai"
              :class="{
                input: true,
                'is-danger': errors.has('Waktu Pelaksanaan'),
              }"
              style="background-color: white"
            ></b-form-input>
            <span class="text-danger" v-if="errors.has('Waktu Pelaksanaan')">
              {{ errors.first('Waktu Pelaksanaan') }}
            </span>
          </div>
        </div>

        <div v-else :class="['col-12', { 'pe-none': is_selesai }]">
          <div class="mt-3">
            <label>Keterangan (Alasan belum dilaksanakan)</label>
            <ckeditor
              id="keterangan_pemenuhan_kewajiban"
              :editor="wygEditor"
              v-model="form.keterangan_alasan"
              name="Keterangan Alasan"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Keterangan Alasan')">
              {{ errors.first('Keterangan Alasan') }}
            </span>
          </div>
          <div class="mt-3">
            <label> Rencana Tindak Lanjut (Penjelasan kapan bagaimana rencana akan dilaksanakan) </label>
            <ckeditor
              id="rencana_tindak_lanjut"
              :editor="wygEditor"
              v-model="form.rencana_tindak_lanjut"
              name="Rencana Tindak Lanjut"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Rencana Tindak Lanjut')">
              {{ errors.first('Rencana Tindak Lanjut') }}
            </span>
          </div>
        </div>

        <div class="col-md-6 mt-3">
          <label>Upload dokumentasi/bukti dukung</label>
          <div class="row">
            <div>
              <small>Format file: PDF</small>
            </div>
            <div class="col-6">
              <b-form-file
                v-model="form.dokumentasi"
                id="dokumentasi"
                plain
                class="form-control"
                name="Dokumentasi"
                accept=".pdf"
                :disabled="is_selesai"
              ></b-form-file>
            </div>
            <div class="col-6 d-flex">
              <a
                v-if="!is_selesai"
                :class="['btn btn-primary mr-2 text-white', { disabled: form.dokumentasi === null }]"
                @click="uploadFile"
              >
                <i class="fa fa-cloud-upload" />
                Unggah
              </a>
              <a
                :class="{
                  'btn btn-success': true,
                  disabled: !id_file_bukti_dukung,
                }"
                @click="unduhFile(id_file_bukti_dukung)"
              >
                <i class="fa fa-download" />
                Unduh
              </a>
            </div>
          </div>
          <span class="text-danger" v-if="errors.has('Dokumentasi')">
            {{ errors.first('Dokumentasi') }}
          </span>
          <span class="text-danger" v-if="errors.has('dokumentasi', 'custom')">
            {{ errors.first('dokumentasi', 'custom') }}
          </span>
        </div>
      </div>

      <div :class="[{ 'pe-none': is_selesai }]">
        <label>Keterangan Lainnya</label>
        <ckeditor @ready="onEditorReady" :editor="wygEditor" v-model="form.keterangan_lainnya"></ckeditor>
      </div>

      <div class="mt-3 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
    </b-form>

    <b-modal :id="`modal-indentify${page}`" :title="`Panduan`" size="md" body-bg-variant="white">
      <template>
        <div>
          {{ panduanKewajiban }}
        </div>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="$bvModal.hide(`modal-indentify${page}`)">
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import Swal from 'sweetalert2'
import { decimalMask } from '../../../helper/validationHelper'

export default {
  components: {
    vSelect,
  },
  props: ['formTitle', 'page', 'panduanKewajiban'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: {
        status_kewajiban: 'Sudah',
        bentuk_kegiatan: '',
        lokasi_kegiatan: '',
        nominal_csr: '0',
        luasan_csr: '0',
        waktu_pelaksanaan: null,
        keterangan_alasan: '',
        rencana_tindak_lanjut: '',
        dokumentasi: null,
        keterangan_lainnya: '',
      },
      is_selesai: false,
      status_laporan: null,
      id_file_bukti_dukung: null,
      optionStatus: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum', text: 'Belum' },
      ],
      wygEditor: ClassicEditor,
    }
  },
  methods: {
    decimalMask,

    uploadFile() {
      this.$loading(true)
      const formData = new FormData()
      formData.append(`file_bukti_dukung_${this.page}`, this.form.dokumentasi)

      axios
        .post(this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then(async (res) => {
          this.$toasted.success('Berhasil Diunggah')
          this.id_file_bukti_dukung = res.data.data[`id_file_bukti_dukung_${this.page}`]
          this.form.dokumentasi = null
        })
        .catch((err) => {
          this.$toasted.danger('Gagal Diunggah')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      this.errors.clear()
      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append(`status_kewajiban_${this.page}`, this.form.status_kewajiban)
          if (this.form.status_kewajiban === 'Sudah') {
            formData.append(`bentuk_kegiatan_${this.page}`, this.form.bentuk_kegiatan)
            formData.append(`lokasi_kegiatan_${this.page}`, this.form.lokasi_kegiatan)
            formData.append(`waktu_pelaksanaan_kegiatan_${this.page}`, this.form.waktu_pelaksanaan)
            formData.append(`nominal_csr_${this.page}`, parseInt(this.form.nominal_csr.replaceAll('.','')))
            formData.append(`luasan_csr_${this.page}`, this.form.luasan_csr)
          } else {
            formData.append(`alasan_belum_dilaksanakan_${this.page}`, this.form.keterangan_alasan)
            formData.append(`rencana_tindak_lanjut_${this.page}`, this.form.rencana_tindak_lanjut)
          }
          formData.append(`keterangan_lainnya_${this.page}`, this.form.keterangan_lainnya)
          if (this.page === 16) {
            formData.append('status_laporan', 'Draft')
          }
        }

        return axios
          .post(this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((res) => {
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        return false
      }
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `The ${fieldName} field is required`,
      })
    },

    onEditorReady() {
      this.loadLaporanTahunan()
    },

    loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      axios
        .get(`${this.baseapiPengendalian}api/laporan_tahunan/${this.$route.query.id_laporan}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const data = res.data.data
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          this.status_laporan = data.status_laporan

          this.form.status_kewajiban = data[`status_kewajiban_${this.page}`] || 'Sudah'
          if (this.form.status_kewajiban === 'Sudah') {
            this.form = {
              ...this.form,
              bentuk_kegiatan: data[`bentuk_kegiatan_${this.page}`] || '',
              lokasi_kegiatan: data[`lokasi_kegiatan_${this.page}`] || '',
              waktu_pelaksanaan: data[`waktu_pelaksanaan_kegiatan_${this.page}`] || null,
              nominal_csr: data[`nominal_csr_${this.page}`].replace(/\B(?=(\d{3})+(?!\d))/g, '.') || '0',
              luasan_csr: data[`luasan_csr_${this.page}`] || '0',
              dokumentasi: null,
              keterangan_lainnya: data[`keterangan_lainnya_${this.page}`] || '',
            }
          } else {
            this.form = {
              ...this.form,
              keterangan_alasan: data[`alasan_belum_dilaksanakan_${this.page}`] || '',
              rencana_tindak_lanjut: data[`rencana_tindak_lanjut_${this.page}`] || '',
              dokumentasi: null,
              keterangan_lainnya: data[`keterangan_lainnya_${this.page}`] || '',
            }
          }
          this.id_file_bukti_dukung = data[`id_file_bukti_dukung_${this.page}`]
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async unduhFile(id) {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/files/download/${id}`,
        this.getApiOption({ responseType: 'blob' }),
      )
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
}
</script>

<style>
.input-rupiah {
  position: relative;
  overflow: hidden;
}

.input-rupiah .text-units {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 0px;
  margin: 0.375rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0);
}

.input-rupiah input {
  padding-left: 2.5rem;
}
</style>
